// import axiosInstance from "../../Services/axiosCommon";
// import Pdf from "../Icons/Pdf";
// import Xls from "../Icons/Xls";
// import NuDate from "./NuDate";


// export const DownloadPDF = ({ url, fileName, params }) => {
//     const downloadPDF = async () => {
//         try {
//             const response = await axiosInstance.get(`${url}`,{params}, {
//                 responseType: 'blob' // Important to specify the response type as blob
//             });
    
//             // Create a Blob from the response
//             const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    
//             // Create a link element
//             const link = document.createElement('a');
//             link.href = window.URL.createObjectURL(pdfBlob);
//             link.download = `${fileName} ${NuDate({value:new Date(),format:"DD-MM-YYYY"})}.pdf`; // The filename you want for the downloaded file
    
//             // Append the link to the body (required for Firefox)
//             document.body.appendChild(link);
    
//             // Programmatically click the link to trigger the download
//             link.click();
    
//             // Clean up and remove the link
//             link.parentNode.removeChild(link);
    
//         } catch (error) {
//             console.error('Error downloading the PDF:', error);
//         }
//     };
//     return(
//         <button onClick={downloadPDF}>
//         <Pdf />
//       </button>
//     )
// }



// export const DownloadXLXS = ({ url, fileName, params }) => {
//     const downloadxlsx = async () => {
//         try {
//             const response = await axiosInstance.get(`${url}`, {
//                 params, 
//                 responseType: 'blob' // Important to specify the response type as blob
//             });
    
//             // Create a Blob from the response
//             const xlsxBlob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
//             // Create a link element
//             const link = document.createElement('a');
//             link.href = window.URL.createObjectURL(xlsxBlob);
//             link.download = `${fileName} ${NuDate({value: new Date(), format: "DD-MM-YYYY"})}.xlsx`;
    
//             // Append the link to the body (required for Firefox)
//             document.body.appendChild(link);
    
//             // Programmatically click the link to trigger the download
//             link.click();
    
//             // Clean up and remove the link
//             document.body.removeChild(link);
    
//         } catch (error) {
//             console.error('Error downloading the xlsx:', error);
//         }
//     };
//     return(
//         <button onClick={downloadxlsx}>
//         <Xls />
//       </button>
//     )
// }


import axiosInstance from "../../Services/axiosCommon";
import Pdf from "../Icons/Pdf";
import Xls from "../Icons/Xls";
import { formatDate } from "./Formdata";


// Download PDF button component
export const DownloadPDF = ({ url, fileName, params }) => {
  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(`${url}`, {
        params,
        responseType: "blob",
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${fileName} ${formatDate(new Date())}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  return (
    <button onClick={downloadPDF}>
      <Pdf />
    </button>
  );
};

// Download XLSX button component
export const DownloadXLXS = ({ url, fileName, params }) => {
  const downloadxlsx = async () => {
    try {
      const response = await axiosInstance.get(`${url}`, {
        params,
        responseType: "blob",
      });

      const xlsxBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(xlsxBlob);
      link.download = `${fileName} ${formatDate(new Date())}.xlsx`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the XLSX:", error);
    }
  };

  return (
    <button onClick={downloadxlsx}>
      <Xls />
    </button>
  );
};
